import { t } from "@lingui/macro";
import * as React from "react";
import {
  ClipPath,
  Defs,
  FeBlend,
  FeColorMatrix,
  FeComposite,
  FeFlood,
  FeGaussianBlur,
  FeOffset,
  Filter,
  G,
  Rect,
} from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const OpenOrderEmpyIcon = (props: IconProps) => (
  <Icon
    width="160"
    height="160"
    viewBox="0 0 160 160"
    fill="none"
    title={t`Open Order Empty`}
  >
    <G clipPath="url(#clip0_5969_52480)">
      <Rect width="160" height="160" rx="80" fill="#F7F7F7" />
      <G filter="url(#filter0_d_5969_52480)">
        <Rect x="20" y="48" width="120" height="112" rx="8" fill="white" />
      </G>
      <Rect x="71" y="68" width="53" height="6" rx="2" fill="#EDEDED" />
      <Rect x="71" y="78" width="26" height="4" rx="2" fill="#EDEDED" />
      <Rect x="36" y="64" width="27" height="27" rx="2" fill="#EDEDED" />
      <Rect x="71" y="103" width="53" height="6" rx="2" fill="#F0F0F0" />
      <Rect x="71" y="113" width="26" height="4" rx="2" fill="#F0F0F0" />
      <Rect x="36" y="99" width="27" height="27" rx="2" fill="#F0F0F0" />
      <Rect x="71" y="138" width="53" height="6" rx="2" fill="#F7F7F7" />
      <Rect x="71" y="148" width="26" height="4" rx="2" fill="#F7F7F7" />
      <Rect x="36" y="134" width="27" height="27" rx="2" fill="#F7F7F7" />
    </G>
    <Defs>
      <Filter
        id="filter0_d_5969_52480"
        x="-12"
        y="32"
        width="184"
        height="176"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <FeFlood flood-opacity="0" result="BackgroundImageFix" />
        <FeColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <FeOffset dy="16" />
        <FeGaussianBlur stdDeviation="16" />
        <FeComposite in2="hardAlpha" operator="out" />
        <FeColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
        />
        <FeBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_5969_52480"
        />
        <FeBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_5969_52480"
          result="shape"
        />
      </Filter>
      <ClipPath id="clip0_5969_52480">
        <rect width="160" height="160" rx="80" fill="white" />
      </ClipPath>
    </Defs>
  </Icon>
);
